<div class="d-flex fd-col">
  <mat-nav-list class="flex-1">
    <suvo-bi-list-navigation-item
      *ngFor="let link of links"
      [link]="link"
      [showIcons]="showIcons"
      [borderRadius]="borderRadius"
      [theme]="theme"
      (onLinkClick)="onLinkClick.emit($event)"
    ></suvo-bi-list-navigation-item>
    <ng-content></ng-content>
  </mat-nav-list>
  <a
    *ngIf="showAskAQuestion"
    class="request-info-box d-flex fd-row jc-start ai-center"
    (click)="openRequestInfo()"
  >
    <mat-icon>help_outline</mat-icon>
    &nbsp;
    <span>Ask us a question</span>
  </a>
</div>
